import { render, staticRenderFns } from "./StudentScholarship.vue?vue&type=template&id=30bfc8fd&"
import script from "./StudentScholarship.vue?vue&type=script&lang=js&"
export * from "./StudentScholarship.vue?vue&type=script&lang=js&"
import style0 from "./StudentScholarship.vue?vue&type=style&index=0&id=30bfc8fd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports